import { gql } from "apollo-boost";

export const GET_ORGANISATION = gql`
  query consumerGetOrganisation {
    consumerGetOrganisation {
      id
      autoRateType
      autoChargeEnabled
      closeGroupSharingEnabled
      serviceRequestEnabled
      allowContactlessBookings
      enableExtendedTestDrive
      standardTestDriveDuration {
          active
          hour
        }
      address {
        street
        city
        state
        country
        zipcode
        fullAddress
      }
      locale
      bookingCategories {
        isActive
        type
        default
        isDriverAllocationRuleEnabled
        isContractHire
      }
      name
      emailId
      phoneNumber
      logoUrl
      supplierPortalEnabled
      enableProtectionPlanForPCO
      owner {
        id
        email
      }
      currency
      orgVatNumber
      orgRegNumber
      stripeAccountId
      globalPaymentCredentials {
        gpAppId
        gpAppKey
      }
      requiresCustomerVerification
      requiresLoginForBooking
      allowSubscriptionBookings
      crossLocationBookingEnabled
      discountModuleEnabled
      branches {
        id
        timeZone
        name
        phoneNumber
        emailId
        depositCollection
        locations {
          id
          name
          branch {
            name
            id
          }
        }
        owner {
          id
          email
        }
        addTaxOptIn
        taxes {
          id
          title
          rate
          type
          value
          subdivisionOptIn
          subdivisionType
          subdivisionRate
          subdivisionValue
        }
      }
    }
  }
`;

export const GET_APP_SETTING = gql`
  query consumerGetAppSetting {
    consumerGetAppSetting {
      id
      hideFilters
      allowedRateTypes
      allowedBillingFrequencies
      appName
      organisationId
      branchIds
      privacyPolicyURL
      tenantId
      provider
      callbackUris
      clientId
      clientSecret
      firstParty
      companyWebsite
      bookingTypes
      pcoRentalOnly
      multipleVehicleBooking
      hideInsurance
      isMultiOrganisation
      minLeadTimeOptIn
      minLeadTimeValue
      minLeadTimeUnit
      maxLeadTimeOptIn
      maxLeadTimeValue
      maxLeadTimeUnit
      subscriptionSettings {
        dvlaVerificationEnabled
        creditCheckEnabled
        idvEnabled
      }
      termsAndConditionsURL
      branches {
        id
        timeZone
        name
        enableQuoteInfo
        quoteInfo
        enableBookingQuestions
        emailId
        depositCollection
        distanceUnit
        overbookingAllowed
        locations {
          id
          name
          branch {
            name
            id
          }
          address {
            fullAddress
            zipcode
            geometry {
              type
              latitude
              longitude
            }
            street
            city
            state
            country
          }
        }
        activeLocations {
          id
          name
          branch {
            name
            id
            phoneNumber {
              phone
              country
            }
            riskBasedPricingEnabled
          }
          address {
            fullAddress
            zipcode
            geometry {
              type
              latitude
              longitude
            }
            street
            city
            state
            country
          }
        }
        operatingHours {
          day
          dayIndex
          pickupFromTime
          pickupToTime
          returnFromTime
          returnToTime
          closed
          allowDropOffs
        }
        minBookingDuration
        maxBookingDuration
        minimumBookingAmount {
          type
          value
        }
        minBookingAmountOptIn
        minBookingDurationOptIn
        maxBookingDurationOptIn
        preBookingQuestions {
          question
          answerType
          required
          expectedAnswer
          options
          errorMessage
          B2B
          B2B2C
        }
        holidays {
          id
          name
          startDate
          endDate
          isActive
          allowDropOffs
        }
        addTaxOptIn
        taxes {
          id
          title
          rate
          type
          value
          isVehicleGroupSpecific
          vehicleGroups
          subdivisionOptIn
          subdivisionType
          subdivisionRate
          subdivisionValue
        }
        vehiclePreparationTime
        phoneNumber {
          phone
          country
        }
        riskBasedPricingEnabled
      }
      branding {
        brandColors
        buttonColor
        accentColor
      }
      isActive
      tenancy {
        chargebeeAddons
        loginEnabled
        logisticsEnabled
        identityVerification {
          provider
          enabled
          id
        }
      }
      organisation {
        id
        autoRateType
        enableBookingCreationForApprovedDriver
        enableSelfServiceBookingExtension
        autoChargeEnabled
        closeGroupSharingEnabled
        enableExtendedTestDrive
        allowContactlessBookings
        fleetAllocationEnabled
        hideYearFilter
        standardTestDriveDuration {
          active
          hour
        }
        bookingCategories {
          isActive
          type
          default
          isDriverAllocationRuleEnabled
          isContractHire
        }
        enableCostCenter
        enableProjectIds
        serviceRequestEnabled
        maxImagesPerDamage
        costCenters {
          name
          projectIds
        }
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
        locale
        name
        emailId
        phoneNumber {
          phone
          country
        }
        termsAndConditions {
          rentalUrl
          subscriptionUrl
          testDriveUrl
        }
        requiresCustomerVerification
        requiresLoginForBooking
        allowSubscriptionBookings
        crossLocationBookingEnabled
        allowCarSharing
        discountModuleEnabled
        logoUrl
        supplierPortalEnabled
        enableProtectionPlanForPCO
        owner {
          id
          email
        }
        currency
        orgVatNumber
        orgRegNumber
        stripeAccountId
        globalPaymentCredentials {
          gpAppId
          gpAppKey
        }
        allowSubscriptionBookings
        convergeEnabled
        extendedTestDriveMaxHours
        enablePaymentProcessingFee
        paymentProcessingFee {
          paymentMode
          gateways {
            paymentGateway
            feeType
            value
          }
        }
      }
      webAppSetting {
        websiteTitle
        websiteIcon
        websiteLogo
        domain
        websiteHeader
        websiteDescription
        logoSize
        htmlDescription
        hasCarousel
        carousel
        hasGallery
        gallery
        websiteAddress
        googleGTMId
        enableBusinessCustomerSignup
        vatInclusivePricingEnabled
        paymentGateway
        hasFeaturedOffers
        featuredOffers {
          offerId
          imageUrl
        }
        enableUserDropoffTrackingWebsite
      }
      mobileAppSetting {
        appIcon
        companyIcon
        straplineIcon
        landingPageIcon
      }
      disableSelfRegistration
      enableBookingEnquiry
      vehicleDetailsSettings {
        showVehicleOnGroup
        showAddons
        categories {
          specification {
            enabled
            fields {
              numberOfDoors
              numberOfSeats
              transmission
              color
              fuelType
            }
          }
          interiorFeatures {
            enabled
          }
          exteriorFeatures {
            enabled
          }
          safetyAndTech {
            enabled
          }
          otherFeatures {
            enabled
          }
        }
      }
    }
  }
`;
